import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/project/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/project/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/project/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/project/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/project/update', params,options);

//项目下拉框
export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

export const getUserlist = (params, options) =>
  request.get('/api/v4ward/user/userList', Object.assign({}, options, { params }));

export const getDeptTreeByIds = (params, options) =>
  request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

//     获取当前登录人部门及子部门节点树/v4ward/dept/treeByIds
export const treeByIds = (params, options) =>
    request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

export const wxParamSubmit = (params, options) =>
  request.post('/api/v4ward/project/wx/param/submit', params,options);
export const wxParamDetail = (params, options) =>
  request.get('/api/v4ward/project/wx/param/detail', Object.assign({}, options, { params }));  